module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAS1BMVEUAAADN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uR0tFsOAAAAGHRSTlMAYQJQgmvXnusVcrys8kOx5Hm4Z97Kj1warcpjAAAAaklEQVQI12WOSQ6AIBRDPyKTODGo//4ntYAkGrtp36JN6afhst65TcuGIz+aKk4dRUXT8QSsM4JXKcLMShaWA4o7wk4MGc2sa4cWRsT4mBEWkh42K1UmonwvGypKHdX3VWifhd2cO6wYiG4EHQp6lZD/KgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z0.png
// module id = jp0m
// module chunks = 16